/* Acumen PDP urgency band — countdown + progress fill.
   Deadline anchored to section settings; recomputed each pageview.
   Owner can adjust the deadline in the theme editor without touching JS. */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function parseIso(iso) {
    // YYYY-MM-DD → local midnight Date, no timezone drift.
    if (!iso) return null;
    var parts = iso.split('-');
    if (parts.length !== 3) return null;
    return new Date(+parts[0], +parts[1] - 1, +parts[2]);
  }
  function daysBetween(a, b) {
    return Math.round((b.getTime() - a.getTime()) / 86400000);
  }
  function fmt(d) {
    return d.getDate() + ' ' + MONTHS[d.getMonth()];
  }
  function setText(el, txt) { if (el) el.textContent = txt; }

  // 26 Oct: elm band (wrapped in data-xmas-show="a b") follows the shared site clock, AcumenXmas.state()
  function renderShared(root, X) {
    var s = X.state(); if (!s.open || s.unknown) return false;
    var hTot = s.d * 24 + s.h, big, eye;
    if (s.d >= 1) { big = String(s.d); eye = (s.d === 1 ? 'day' : 'days') + ' ' + s.h + (s.h === 1 ? ' hr' : ' hrs') + ' to order for pre-Christmas delivery'; }
    else if (hTot >= 1) { big = String(hTot); eye = 'Last day \u00b7 ' + (hTot === 1 ? 'hour' : 'hours') + ' left to order for Christmas'; }
    else { big = String(s.m); eye = 'Last orders \u00b7 minutes left to order for Christmas'; }
    setText(root.querySelector('[data-role="days"]'), big);
    setText(root.querySelector('.apu-eye'), '\u25e6 Reclaimed elm \u00b7 ' + eye);
    var inl = root.querySelector('[data-role="days-inline"]');
    if (inl && inl.parentNode) { inl.parentNode.lastChild.nodeValue = ''; setText(inl, s.left + ' left'); }
    setText(root.querySelector('[data-role="tick-today"]'), 'Today \u00b7 ' + s.left + ' left');
    root.classList.toggle('is-close', true);
    return true;
  }

  function render(root) {
    var X = window.AcumenXmas;
    if (X && X.state && X.tick && root.closest('[data-xmas-show="a b"]')) {
      if (!root.__adl) { root.__adl = true; X.tick(function(){ renderShared(root, X); }); }
      if (renderShared(root, X)) { renderFill(root); return; }
    }
    var deadline = parseIso(root.getAttribute('data-deadline'));
    var start    = parseIso(root.getAttribute('data-start'));
    var leadMin  = parseInt(root.getAttribute('data-lead-min'), 10) || 8;
    var leadMax  = parseInt(root.getAttribute('data-lead-max'), 10) || 10;
    if (!deadline) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var daysLeft = daysBetween(today, deadline);

    // Days number + inline text
    setText(root.querySelector('[data-role="days"]'), daysLeft > 0 ? String(daysLeft) : '0');
    setText(root.querySelector('[data-role="days-inline"]'), daysLeft > 0 ? String(daysLeft) : '0');

    // Cutoff date, formatted from the deadline itself so admin-edited dates just work
    setText(root.querySelector('[data-role="cutoff-date"]'), fmt(deadline));

    // Arrival window — today + lead time
    var arrMin = new Date(today.getTime()); arrMin.setDate(arrMin.getDate() + leadMin * 7);
    var arrMax = new Date(today.getTime()); arrMax.setDate(arrMax.getDate() + leadMax * 7);
    setText(root.querySelector('[data-role="arrival"]'), fmt(arrMin) + ' – ' + fmt(arrMax));

    // Ticks — start, today, deadline
    if (start) setText(root.querySelector('[data-role="tick-start"]'), fmt(start));
    setText(root.querySelector('[data-role="tick-today"]'),
            'Today · ' + Math.max(0, daysLeft) + ' left');
    setText(root.querySelector('[data-role="tick-end"]'), fmt(deadline));

    // Progress fill — start to deadline; today's share fills the bar
    var fill = root.querySelector('[data-role="fill"]');
    if (fill && start) {
      var total = daysBetween(start, deadline);
      var done  = daysBetween(start, today);
      var pct   = total > 0 ? Math.max(0, Math.min(100, (done / total) * 100)) : 0;
      // Defer to next frame so the width transition animates on load
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    }

    // State classes for CSS to ramp urgency
    root.classList.remove('is-close', 'is-past');
    if (daysLeft <= 0) root.classList.add('is-past');
    else if (daysLeft <= 14) root.classList.add('is-close');
  }

  function renderFill(root) {
    var deadline = parseIso(root.getAttribute('data-deadline')), start = parseIso(root.getAttribute('data-start'));
    var fill = root.querySelector('[data-role="fill"]'); if (!fill || !start || !deadline) return;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var total = daysBetween(start, deadline), done = daysBetween(start, today);
    var pct = total > 0 ? Math.max(0, Math.min(100, (done / total) * 100)) : 0;
    requestAnimationFrame(function () { fill.style.width = pct + '%'; });
  }

  function init() {
    document.querySelectorAll('.acumen-pdp-urgency').forEach(render);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

